@import (reference) '../common-styles.module.less';

.order-details-branding {
  .settings-sub-section();
  display: flex;
  flex-direction: column;

  .details-checkbox {
    .sub-checkbox();
    margin: 10px 20px;
  }
}

.disabled-mask {
  &:extend(.disabled-mask);
}
